import React from "react";
import SignupLayout from "../../components/Signup/SignupLayout";
import SingupAccount from "../../components/Signup/SignupAccount";
import { Redirect, useParams } from "react-router-dom";

const SignupContainer = () => {
  const params = useParams();

  const SignUpForm = (
    <SignupLayout>
      {/* <SignupWelcome /> */}
      <SingupAccount referralId={params.id} />
      {/* <SignupVerify /> */}
      {/* <SignupRestored /> */}
    </SignupLayout>
  );
  const token = localStorage.getItem("jwt_token");
  if (!token) {
    return SignUpForm;
  } else if (
    localStorage.getItem("profile_id") &&
    localStorage.getItem("is_profile_setup")
  ) {
    return <Redirect to="/dashboard" />;
  } else {
    return SignUpForm;
  }
};

export default SignupContainer;
